const state = {
    loading: false,
    open_filter: false
}

// getters
const getters = {
    /*getWorkGroup () {
        return state.work_group_id;
    }*/
}

// mutations
const mutations = {
    startLoading: (state) => {
        state.loading = true
    },
    stopLoading: (state) => {
        state.loading = false
    },
    openFilter: (state) => {
        state.open_filter = !state.open_filter
    },
};

// actions
const actions = {
    startLoading: (context) => {
		context.commit('startLoading')
    },
    stopLoading: (context) => {
		context.commit('stopLoading')
    },
    openFilter: (context) => {
		context.commit('openFilter')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}